import { Tab, Tabs } from '@customink/pigment-react';
import { PageHeader } from '~/components/PageHeader/PageHeader';
import { useRouteTabs } from '~/components/hooks/useRouteTabs';
import {
    AccountPath,
    AccountPathsGroup,
    PaymentsPath,
    PostalAddressesPath,
    SettingsPath,
    TaxExemptionPath,
} from '~/config';
import { SectionContent } from '~/components/Layout/SectionContent';
import { useFeatureFlagEnabled } from '~/adapters/optimizely/accounts';
import { ErrorBoundary } from '~/components/ErrorBoundary';
import { AccountTab } from '~/pages/Settings/tabs/Account/AccountTab';
import { PaymentMethodsTab } from '~/pages/Settings/tabs/PaymentMethods/PaymentMethodsTab';
import { TaxExemptionTab } from './tabs/TaxExemption/TaxExemptionTab';
import { PostalAddressesTab } from './tabs/PostalAddresses/PostalAddressesTab';
import { ProfileTab } from './tabs/Profile/ProfileTab';

export function Account() {
    const [selectedPath, selectPath] = useRouteTabs(...AccountPathsGroup);

    const isTeamAccountsFeatureFlagEnabled = useFeatureFlagEnabled('team_accounts');

    return (
        <>
            <PageHeader>Account Settings</PageHeader>
            <ErrorBoundary errorMessage="An error ocurred while loading your account settings">
                <Tabs
                    variant="scrollable"
                    allowScrollButtonsMobile
                    value={selectedPath}
                    onChange={(_, val) => selectPath(val)}
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Profile" value={SettingsPath} />
                    {isTeamAccountsFeatureFlagEnabled && <Tab label="Account" value={AccountPath} />}
                    <Tab label="Payment Methods" value={PaymentsPath} />
                    <Tab label="Tax Exemption" value={TaxExemptionPath} />
                    <Tab label="Addresses" value={PostalAddressesPath} />
                </Tabs>
                <SectionContent>
                    {selectedPath === SettingsPath && <ProfileTab />}
                    {selectedPath === AccountPath && isTeamAccountsFeatureFlagEnabled && <AccountTab />}
                    {selectedPath === PaymentsPath && <PaymentMethodsTab />}
                    {selectedPath === TaxExemptionPath && <TaxExemptionTab />}
                    {selectedPath === PostalAddressesPath && <PostalAddressesTab />}
                </SectionContent>
            </ErrorBoundary>
        </>
    );
}
